import { render, staticRenderFns } from "./SafeControlList.vue?vue&type=template&id=65fc2ee4&scoped=true"
import script from "./SafeControlList.vue?vue&type=script&lang=js"
export * from "./SafeControlList.vue?vue&type=script&lang=js"
import style0 from "./SafeControlList.vue?vue&type=style&index=0&id=65fc2ee4&prod&lang=scss"
import style1 from "./SafeControlList.vue?vue&type=style&index=1&id=65fc2ee4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fc2ee4",
  null
  
)

export default component.exports